import { useContext } from "react";

import {
  SearchContext,
  SearchContextInterface,
} from "../contexts/search/context";

export const useSearch = (): SearchContextInterface =>
  useContext(SearchContext);
